import type { Cabinet } from '@sirius/contracts/admin'
import type { TFunction } from 'i18next'

/**
 * The key button on the cabinet page: "Issue key" for a cabinet without one,
 * "Rotate key" (behind a confirmation, the old key stops working) otherwise.
 * Decommissioned cabinets never connect again, so they get none.
 */
export function keyActionFor(
  cabinet: Pick<Cabinet, 'status' | 'keyIssuedAt'>,
  t: TFunction,
) {
  if (cabinet.status === 'decommissioned') {
    return null
  }
  return cabinet.keyIssuedAt === null
    ? ({ label: t('cabinetsPage.key.issue'), rotate: false } as const)
    : ({ label: t('cabinetsPage.key.rotate'), rotate: true } as const)
}
